import { Dispatch } from "redux"
import { LabelAdditionalData } from "."
import { AppStateWithData } from "../../.."
import { ApiConfig, CollectionLabel, createRequestActionTypes, createRequestThunk, RequestThunkParameters } from "../../../.."

export const editLabelActionTypes = createRequestActionTypes('EDIT_LABEL')

type EditLabel = { 
    color: string,
    name: string,
    collectionId: number 
    id: number
}

export const editLabel = (config: ApiConfig) => (label: EditLabel, collectionId: number) => (dispatch: Dispatch, getState: () => AppStateWithData) => {
    const thunkParams: RequestThunkParameters<CollectionLabel, EditLabel, LabelAdditionalData> = {
        method: 'POST',
        requestActionTypes: editLabelActionTypes,
        url: `${config.API_URL}/collectionLabels/edit`,
        actionAdditionalData: {
            collectionId,
        },
        body: label
    }

    return dispatch<any>(createRequestThunk(thunkParams))
}